import { PlanetProofReport } from '../models';

export function isPlanetProofCalculationComplete(
  report: PlanetProofReport,
  usingArableReport: boolean,
): boolean {
  if (!report) return false;
  if (report.calculationStatus && report.calculationStatus !== 'complete') return false;
  // Old rebuild responses cannot attest to source completeness, even if their totals are zero.
  if (usingArableReport && report.calculationStatus !== 'complete') return false;
  return report.cropFields.every((field) =>
    field.adviceId !== 0 && Array.isArray(field.cropAids) &&
    (!usingArableReport || (field.adviceId > 0 && [
      field.totalActiveMatter, field.totalBonus, field.totalMalus, field.saldo,
    ].every(Number.isFinite))),
  );
}
